<script>
import {
  transcriptStatusMeta,
  aiStatusMeta,
} from '@modules/crm/constants/Transcript'

// O modal manda '-' quando não há data/duração conhecida.
const PLACEHOLDER_VAZIO = '-'

const STATUS_EM_ANDAMENTO = 'in_progress'

// Linha corrida de metadados do cabeçalho: data, duração, status da transcrição,
// status do resumo e profissional, separados por "·". Substitui a fila de chips
// cinzas do cabeçalho antigo.
export default {
  name: 'TranscriptHeaderMeta',
  props: {
    startTimeFormatted: { type: String, default: '-' },
    duration: { type: String, default: '-' },
    status: { type: String, default: '' },
    aiStatus: { type: String, default: '' },
    profissional: { type: String, default: '' },
  },
  computed: {
    // formatBackendDateTime devolve 'DD/MM/YYYY HH:mm'; aqui só entra o "às"
    // entre data e hora. Valor ausente ('-') passa direto.
    dataLabel() {
      const value = this.startTimeFormatted || ''
      const parts = value.split(' ')
      if (parts.length !== 2) return value
      return parts[0] + ' às ' + parts[1]
    },
    hasDuration() {
      if (!this.duration || this.duration === PLACEHOLDER_VAZIO) return false
      return this.status !== STATUS_EM_ANDAMENTO
    },
    statusMeta() {
      return transcriptStatusMeta(this.status)
    },
    resumoMeta() {
      return aiStatusMeta(this.aiStatus)
    },
    // Itens já filtrados e prontos para o v-for — o template não decide nada.
    // O '-' é o placeholder de ausência do modal e é truthy: filtrar explícito,
    // senão vira um item vazio no meio da linha.
    items() {
      const items = []
      if (this.dataLabel && this.dataLabel !== PLACEHOLDER_VAZIO) {
        items.push({ key: 'data', icon: 'calendar', text: this.dataLabel })
      }
      // Reunião em curso: o modal devolve 'Em andamento' como duração e o item
      // de status já diz "Transcrição em andamento" — só o status fica.
      if (this.hasDuration) {
        items.push({ key: 'duracao', icon: 'clock', text: this.duration })
      }
      if (this.statusMeta) {
        items.push({ key: 'status', text: this.statusMeta.label })
      }
      if (this.resumoMeta) {
        items.push({ key: 'resumo', text: this.resumoMeta.label })
      }
      if (this.profissional) {
        items.push({
          key: 'profissional',
          icon: 'user-tag',
          text: this.profissional,
        })
      }
      return items
    },
  },
}
</script>

<template>
  <div class="d-flex flex-wrap align-center az-gap-xsmall az-ds-aux">
    <span
      v-for="(item, index) in items"
      :key="item.key"
      class="d-inline-flex align-center"
    >
      <span v-if="index > 0" class="mr-1">·</span>
      <icon-svg
        v-if="item.icon"
        :name="item.icon"
        :size="14"
        class="mr-1"
      />
      <span>{{ item.text }}</span>
    </span>
  </div>
</template>
